<template>
	<div class="post-page-container">
		<div
			class="post__fake-btn-modal-container mt-5"
			@click="openCreatePostModal"
			v-if="!this.isLoading"
		>
			<div>
				<Avatar
					class="mr-4 post-preview-card__avatar"
					size="30"
					:avatar="profile.user_logo"
				/>
				What’s on your mind?
			</div>

			<div>
				<img :src="penIcon" alt="penIcon" loading="lazy" />
			</div>
		</div>

		<v-card
			class="post-preview-card elevation-0 d-flex flex-column mt-5"
		>
			<div class="post-preview-card__container">
				<div class="post-preview-card__outer">
					<div class="d-flex post-preview-card__list px-4 py-4">
						<div class="mb-4">
							<router-link
								:to="{
								name: 'forums-by-category-id',
								params: {id: categoryId}
							}"
								class="d-flex text-decoration-none"
							>
								<v-icon small class="mr-1"> mdi-arrow-left-circle</v-icon>
								<div class="event-card__link">Forum</div>
							</router-link>
						</div>

						<div class="post-preview-card__title">
							{{ categoryName }}
						</div>
					</div>
				</div>
			</div>
		</v-card>

		<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card"></v-skeleton-loader>
		<Forum v-else :forum="this.forum"/>

		<div v-if="isShowCreatePostModal">
			<CreatePostModal
				v-on:closeModal="closeCreatePostModal"
				:show="isShowCreatePostModal"
				:categoryId="categoryId"
			/>
		</div>

		<v-btn
			v-show="isShowCreatePostButton"
			@click="openCreatePostModal"
			bottom
			right
			class="add-post-button"
			fixed
			fab
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

		<v-btn
			v-show="isVisible"
			@click="scrollToTop"
			bottom
			right
			fixed
			fab
		>
			<v-icon>mdi-chevron-up</v-icon>
		</v-btn>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import Forum from '@/components/Forum/Forum'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import Avatar from '@/components/Avatar.vue'
import penIcon from '@/assets/images/icon-pen.svg'
export default {
	name: 'ForumPage',
	components: {
		Avatar,
		CreatePostModal,
    Forum,
	},
	data() {
		return {
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
			penIcon,
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false
		}
	},
	computed: {
		...mapGetters('forum', ['forum', 'isLoading']),
		...mapGetters('auth', ['profile']),

		categoryId() {
			if (this.$route.params.id !== undefined) {
				return this.forum.category_id;
			}

			return null
		},

		categoryName() {
			if (this.$route.params.id !== undefined) {
				return this.forum.category_name;
			}

			return ''
		}
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth);
	},


	methods: {
		...mapActions('forum', ['getForum']),
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000;
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264;
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isShowCreatePostModal = false
		}
	},
	watch: {
		isLoading(newValue, oldValue) {
			if (newValue !== oldValue) {
				if ( !newValue && this.$route.query.toBottom !== undefined ) {

					setTimeout(() => {
						window.scrollTo({
							top: document.body.scrollHeight,
							behavior: 'smooth',
						});
					}, 100)

				}
			}
		}
	},
	created() {
		if (this.$route.params.id !== undefined) {
			this.getForum(this.$route.params.id)
		}
	}
}
</script>

<style lang="scss">
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (min-width: 1200px) {
	.post-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.post-page-container {
		max-width: 600px;
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}
	&__btn-filters {
		color: white;
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		letter-spacing: 0.36px;
		margin-top: 20px;
		background: rgb(65, 161, 216) !important;
		border-radius: 15px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
		text-transform: capitalize !important;
		align-items: center;
		margin-right: 15px;
		&-active {
			background-color: #02668a !important;
			color: white !important;
		}
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}
.v-btn {
	background-color: var(--accent-color) !important;
	color: white !important;
}
</style>
